import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AttachFilePageRoutingModule } from './attach-file-routing.module';

import { AttachFilePage } from './attach-file.page';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AttachFilePageRoutingModule,
    NgxDropzoneModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  declarations: [AttachFilePage],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AttachFilePageModule {}
